/*
 * -----------------------------------------------------------------------
 *  <copyright file="edit-risk-overview-config.data.ts" company="Triumph Research Intelligence">
 *      Copyright (C) 2023 by Triumph Research Intelligence. All rights reserved.
 *  </copyright>
 * -----------------------------------------------------------------------
 */

import { IRiskOverviewData } from '@components/admin/studies/study-settings-dialogs/edit-overview-tables/edit-risk-overview-config/edit-risk-overview-config.interface';

export const RISK_OVERVIEW_CHECKBOXES: Array<keyof IRiskOverviewData> = [
    'amberKris',
    'redKris',
    'redDecisionKris',
    'amberDecisionKris',
    'siteStatus',
    'siteActiveDate',
    'siteCountry',
    'siteMonitor',
    'numSubjects',
];
